import CategoryLandingPageList, {
  Category,
  CategoryLandingPageListProps,
} from './CategoryLandingPageList';

export default CategoryLandingPageList;
export type { Category, CategoryLandingPageListProps };
